import type { CountryCodes } from '@/generated/graphql';
import { features, getCheckoutSessionFlags, logger, STATE_NAME } from '@/lib';

export const logFPTIWhenDomesticTransactionBlocked = (
  country: CountryCodes,
): void => {
  logger.fpti(`${country}_domestic_transaction_blocked`, {
    int_error_desc: `Domestic transaction blocked in ${country}`,
    state_name: 'billing',
    transition_name: 'process_billing_error',
  });
};

export const logBillingPageShown = (): void => {
  const { isGuestEligible } = getCheckoutSessionFlags();
  const applePayButtonShown = features.isActive('applePayButtonShown');
  const eventName = 'billing_page_shown';

  logger.fpti(eventName, {
    account_signup_type: isGuestEligible ? 'guest' : 'signup',
    event_name: eventName,
    state_name: STATE_NAME.billing,
    transition_name: 'billing_page_shown',
    ...(applePayButtonShown && {
      flow_name: 'wps_apple_pay',
    }),
  });
};

export const logBillingApplePayButtonShown = (): void => {
  const { isGuestEligible } = getCheckoutSessionFlags();
  const applePayButtonShown = features.isActive('applePayButtonShown');
  const eventName = 'apple_pay_button_shown';

  logger.fpti(eventName, {
    account_signup_type: isGuestEligible ? 'guest' : 'signup',
    event_name: eventName,
    state_name: STATE_NAME.billing,
    transition_name: 'apple_pay_button_shown',
    ...(applePayButtonShown && {
      flow_name: 'wps_apple_pay',
    }),
  });
};

export const logBillingApplePayButtonClicked = (): void => {
  const { isGuestEligible } = getCheckoutSessionFlags();
  const applePayButtonShown = features.isActive('applePayButtonShown');
  const eventName = 'billing_pay_with_other_funding_source_clicked';

  logger.fpti(eventName, {
    account_signup_type: isGuestEligible ? 'guest' : 'signup',
    event_name: eventName,
    selected_funding_option: 'apple_pay',
    state_name: STATE_NAME.billing,
    transition_name: 'pay_with_other_funding_source',
    ...(applePayButtonShown && {
      flow_name: 'wps_apple_pay',
    }),
  });
};
